import type { ReactNode } from 'react';
import { useModuleLicense } from '../../hooks/useModuleLicense';
import { SeatRequired } from '../nursery/accounts/AccountBits';

/**
 * For the few accounts pages the nursery still reads. Customers and price
 * lists are set up with an Accounts seat, but an order is taken for a customer
 * at a price, so the nursery seats named here see the page too. What they can
 * change is decided inside the page, and again by the server.
 */
export default function AccountsOrNurseryGate({ nursery, what, children }: {
  nursery: string[];
  what: string;
  children: ReactNode;
}) {
  const accounts = useModuleLicense('accounts', ['user', 'admin']);
  const grower = useModuleLicense('nursery', nursery);

  if (accounts.loading || grower.loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="h-8 bg-neutral-100 rounded animate-pulse w-64 mb-4" />
        <div className="h-40 bg-neutral-100 rounded animate-pulse" />
      </div>
    );
  }
  if (!accounts.hasAccess && !grower.hasAccess) return <SeatRequired seat="user" what={what} />;
  return <>{children}</>;
}
